import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Capabilities", href: "#capabilities" },
  { label: "Method", href: "#method" },
  { label: "Fleet", href: "#fleet" },
  { label: "Safety", href: "#safety" },
  { label: "Contact", href: "#contact" },
];

export const Nav = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 w-full z-50 transition-colors duration-500 ${
        scrolled ? "bg-[#050B14]/85 backdrop-blur-md border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="w-full px-6 md:px-12 flex items-center justify-between h-20">
        <button
          data-testid="nav-logo"
          onClick={() => go("#top")}
          className="flex items-center gap-3 group"
        >
          <span className="w-3 h-3 bg-accent block group-hover:rotate-45 transition-transform duration-300" />
          <span className="font-display text-xl md:text-2xl tracking-tight">GND SOLUTION</span>
        </button>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              onClick={() => go(l.href)}
              className="font-mono text-xs tracking-[0.2em] uppercase text-[#94A3B8] hover:text-accent transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <button
          data-testid="nav-cta"
          onClick={() => go("#contact")}
          className="hidden md:inline-flex items-center gap-2 bg-accent text-[#050B14] font-mono text-xs tracking-[0.15em] uppercase px-5 py-3 hover:bg-white transition-colors duration-300"
        >
          Request Crew <span aria-hidden>→</span>
        </button>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden text-white"
          onClick={() => setOpen((o) => !o)}
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            data-testid="mobile-menu"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.35 }}
            className="md:hidden overflow-hidden bg-[#0A111D] border-t border-white/10"
          >
            <div className="flex flex-col px-6 py-6 gap-5">
              {links.map((l) => (
                <button
                  key={l.href}
                  data-testid={`mobile-link-${l.label.toLowerCase()}`}
                  onClick={() => go(l.href)}
                  className="text-left font-display text-2xl tracking-tight hover:text-accent transition-colors"
                >
                  {l.label}
                </button>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};
